// Env-scoped cookie name so staging and prod don't collide on the shared `.paywatchglobal.com`
// apex. MUST match the employer portal's envCookieName EXACTLY (it reads these cookies): same
// prefix shape `ep-<env>.<name>`, same env tokens. The portal uses NEXT_PUBLIC_ENV; here the same
// values come from REACT_APP_NODE_ENV (see releaseGuard.ts / index.tsx — "staging"/"production").
export const envCookieName = (name: string): string => {
  return name;
  // const env = (process.env.REACT_APP_NODE_ENV ?? 'local').trim().toLowerCase();
  // return `ep-${env}.${name}`;
};
